export const IS_PRODUCTION =
  process.env.DEPLOYMENT_ENVIRONMENT === 'production';

export const IS_DEVELOPMENT =
  process.env.DEPLOYMENT_ENVIRONMENT === 'development';

export const IS_TEST = process.env.DEPLOYMENT_ENVIRONMENT === 'test';

export const IS_INTEGRATION =
  process.env.DEPLOYMENT_ENVIRONMENT === 'integration';
